/**
 * Card Component - Contenedor base reutilizable
 * Uso: <Card padding="lg" hover shadow="md">...</Card>
 */

import { ReactNode, HTMLAttributes, forwardRef } from "react";

type CardPadding = "none" | "sm" | "md" | "lg";
type CardShadow = "none" | "sm" | "md" | "lg";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padding?: CardPadding;
  shadow?: CardShadow;
  hover?: boolean;
  border?: boolean;
  rounded?: boolean;
}

const paddingStyles: Record<CardPadding, string> = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

const shadowStyles: Record<CardShadow, string> = {
  none: "",
  sm: "shadow-sm",
  md: "shadow-md",
  lg: "shadow-lg",
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      children,
      padding = "md",
      shadow = "sm",
      hover = false,
      border = true,
      rounded = true,
      className = "",
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={`
        bg-white dark:bg-slate-800 ${rounded ? "rounded-xl" : ""} transition-colors duration-200
        ${paddingStyles[padding]}
        ${shadowStyles[shadow]}
        ${border ? "border border-gray-100 dark:border-slate-700" : ""}
        ${hover ? "hover:shadow-md transition-shadow duration-200" : ""}
        ${className}
      `}
        {...props}
      >
        {children}
      </div>
    );
  },
);
Card.displayName = "Card";
